import React, { useState } from 'react';
import { useForm, FormProvider } from "react-hook-form";
import { useTracking } from 'react-tracking';
import { renderComponent } from '../../../helpers/RenderComponent';
import { getTabclixCode } from '../../../helpers/embed-code';
import Button from '../button/Button';
import { fetchAuth, postForms } from '../../../api/tabclixContentApi';

function Form(props) {

  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState(false);

  const formMethods = useForm();
  const { handleSubmit, reset } = formMethods;  // Destructure reset from formMethods
  const { trackEvent } = useTracking();

  const onSubmit = async (data) => {
    try {
      
      setSending(true);
      let code = getTabclixCode();
      data['user_id'] = code;
      
      const authToken = await fetchAuth();
      
      await postForms(authToken, data);
      
      setMessage("Form has been successfully submitted!");
      
      // Reset the form after submission
      reset();
      
    } catch (error) {
      setMessage("An error occurred, please try again later.");
    } finally {
      setSending(false);
    }
  };

  return (
    <FormProvider {...formMethods}>
      {message && <div>{message}</div>}
      
      <form onSubmit={handleSubmit(onSubmit)} disabled={sending}>
        {props.forms.map((child, index) => (
          <div className="Row" key={index}>
            {child.type === "button" ? <Button {...child} state={sending} /> : renderComponent(child)}
          </div>
        ))}
      </form>

    </FormProvider>
  );
}

export default Form;